import { PATH_STORE_WITHOUT_LINKS } from 'common/constants';
import { getStorePathname } from 'common/selectors/location';
import { useSelector } from 'react-redux';

export const useHasServicesLinks = () => {
  const storePathname = useSelector(getStorePathname);

  // NOTE: по умолчанию у всех магазинов есть ссылки.
  if (!storePathname) {
    return true;
  }

  const hasLink = !PATH_STORE_WITHOUT_LINKS.includes(storePathname || '');

  return hasLink;
};
